import ajax from '@/resources/myApi';
import vm from '@/main';

export const service = {
    getRecordsByBrandName,
    getReferenceDrugKnownNDCs,
    updateDrugBrandRecord,
    saveDrugBrandRecord,
    saveReferenceDrugNDCsRecord,
    updateReferenceDrugNDCsRecord,
    checkExistenceReferenceDrugNDC11,
};

//get records by brand name
async function getRecordsByBrandName(pageNumber,
    pageSize,
    sortOrder,
    sortBy,
    filters) {
    const params = {
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    };
    try {
        const { data } = await ajax.get('api/ReferenceDrugHeader/', {
            params
        });
        return data;
    } catch (error) {
        return {};
    }
}

//get reference drug known NDCs
async function getReferenceDrugKnownNDCs
    (
        brandId,
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    ) {

    const params = {
        brandId,
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    };

    try {
        const { data } = await ajax.get('api/ReferenceDrugHeader/GetReferenceDrugNDCsByBrandId', {
            params
        });
        return data;
    } catch (error) {
        return {};
    }
}

//update drug reference brand detail record
async function updateDrugBrandRecord(dto) {
    try {

        const updatedResult = await ajax.post(`api/ReferenceDrugHeader/UpdateReferenceDrugHeader`, {
            body: { vwDto: dto }
        });

        vm.$snotify.success('Record changes updated', 'Drug Detail');

        return updatedResult;

    } catch (error) {
        return {};
    }
}

//save drug reference brand record
async function saveDrugBrandRecord(dto) {
    try {

        const apiResult = await ajax.post(`api/ReferenceDrugHeader`, {
            body: { vwDto: dto }
        });

        vm.$snotify.success('Record changes saved', 'Drug Detail');

        return apiResult;

    } catch (error) {
        return {};
    }
}

//save reference drug NDCs record
async function saveReferenceDrugNDCsRecord(referenceDrugNDCsDto) {
    try {

        const { data } = await ajax.post(`api/ReferenceDrugHeader/SaveReferenceDrugNDCs`,
            {
                body: { vwDto: referenceDrugNDCsDto }
            }
        );

        if (data) {
            vm.$snotify.success('Record changes saved', 'NDCs Detail');
        }

        return data;

    } catch (error) {
        return {};
    }
}

//update reference drug NDCs record
async function updateReferenceDrugNDCsRecord(referenceDrugNDCsDto) {
    try {

        const { data } = await ajax.post(`api/ReferenceDrugHeader/UpdateReferenceDrugNDCs`,
            {
                body: { vwDto: referenceDrugNDCsDto }
            }
        );

        if (data) {
            vm.$snotify.success('Record changes updated', 'NDCs Detail');
        }

        return data;

    } catch (error) {
        return {};
    }
}

//check existence reference drug NDC11
async function checkExistenceReferenceDrugNDC11(ndc11) {
    const params = {
        ndc11
    };

    try {

        const { data } = await ajax.get('api/ReferenceDrugHeader/CheckExistenceReferenceDrugNDC11', {
            params
        });

        return data;

    } catch (error) {
        return {};
    }
}

export default service;